import { render, staticRenderFns } from "./reservationOverviewPage.vue?vue&type=template&id=6f4b5b3e"
import script from "./reservationOverviewPage.vue?vue&type=script&lang=js"
export * from "./reservationOverviewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports